import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Loader.css";
import Backdrop from "../Backdrop/Backdrop";
import Aux from "../../../hoc/Auxi/Auxi";
/**
 * @desc Loader
 * @param props
 * @return null
 */
const Loader = props => {
  const { className, label, children, ...other } = props;
  return (
    <Aux>
      <div className="Loader-background" />
      <div className={"lds-spinner " + className}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </Aux>
  );
};

Loader.propTypes = {
  /** ClassName will be injected into the component's container. You can use ClassName for adhoc styling. */
  className: PropTypes.string,
  /** The label of the textarea */
  label: PropTypes.string
};

Loader.defaultProps = {
  className: "",
  label: ""
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/UI/Loader/Loader.js